export const packageName = process.env._PACKAGE_NAME_ as string;
